module.exports = __webpack_public_path__ + "assets/img/ico_ios.4dd29bf0.svg";